import moment from 'moment';

export const OLD_TIME_OF_DAY_DEFAULT = '09:00';
export const NEW_TIME_OF_DAY_DEFAULT = '00:05';

const standardRecurrenceOptions = {
  daily: {
    dayOfWeek: 'Monday Tuesday Wednesday Thursday Friday',
    timeOfDay: NEW_TIME_OF_DAY_DEFAULT,
    intervalUnit: 'week',
    intervalAmount: 1,
    weekInMonth: null,
    dayInMonth: null,
  },
  weekly_on_monday: {
    dayOfWeek: 'Monday',
    timeOfDay: NEW_TIME_OF_DAY_DEFAULT,
    intervalUnit: 'week',
    intervalAmount: 1,
    weekInMonth: null,
    dayInMonth: null,
  },
  monthly_on_first_monday: {
    dayOfWeek: 'Monday',
    timeOfDay: NEW_TIME_OF_DAY_DEFAULT,
    intervalUnit: 'month',
    intervalAmount: 1,
    weekInMonth: 0,
    dayInMonth: null,
  },
};

export const getRecurrenceAttributesFromOptionValue = optionValue => {
  const data = standardRecurrenceOptions[optionValue];
  if (optionValue === 'monthly_on_first_monday') {
    return { ...data, ...{ startsAt: moment().set('date', 1).isoWeekday(8).format() } };
  }
  return data;
};

export const getSelectedOptionValue = ({
  onlyRecurOnce,
  timeOfDay,
  dayOfWeek,
  intervalUnit,
  intervalAmount,
  weekInMonth,
  recurringWorkspaceItemExists,
}) =>
  (onlyRecurOnce ? 'existing_snooze' : undefined) ||
  Object.keys(standardRecurrenceOptions).find(optionValue => {
    const recurrenceAttributes = standardRecurrenceOptions[optionValue];

    if (
      (timeOfDay === recurrenceAttributes.timeOfDay || timeOfDay === OLD_TIME_OF_DAY_DEFAULT) &&
      dayOfWeek === recurrenceAttributes.dayOfWeek &&
      intervalUnit === recurrenceAttributes.intervalUnit &&
      intervalAmount === recurrenceAttributes.intervalAmount &&
      weekInMonth === recurrenceAttributes.weekInMonth
    ) {
      return true;
    }
    return false;
  }) ||
  (recurringWorkspaceItemExists ? 'custom' : undefined);
